import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FileData } from "../types/api";
import { deleteFile, uploadFile } from "../actions/sharedActions";
// NOTE(liamvdv): need for SDK to set prompts.

interface PromptState {
  text: string;
  // NOTE(liamvdv): explicit disable; different from isLoading
  disabled: boolean;
  show: boolean;
  suggestions?: string[];
  // NOTE(liamvdv): they are usually comming form the API, but may also be set manually by the SDK (set chat.suggestions).
  quickReplies?: string[];
  files: FileData[];
}

const initialState: PromptState = {
  text: "",
  disabled: false,
  show: true,
  suggestions: undefined,
  quickReplies: undefined,
  files: [],
};

const promptSlice = createSlice({
  name: "prompt",
  initialState,
  reducers: {
    setPrompt: (state, action: PayloadAction<string>) => {
      state.text = action.payload;
    },
    setPromptDisabled: (state, action: PayloadAction<boolean>) => {
      state.disabled = action.payload;
    },
    setShowPrompt: (state, action: PayloadAction<boolean>) => {
      state.show = action.payload;
    },
    setSuggestions: (state, action: PayloadAction<string[]>) => {
      state.suggestions = action.payload;
    },
    setQuickReplies: (state, action: PayloadAction<string[]>) => {
      state.quickReplies = action.payload;
    },
    setAttachments: (state, action: PayloadAction<FileData[]>) => {
      state.files = action.payload;
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.files.push(action.payload);
      })
      .addCase(deleteFile.fulfilled, (state, action) => {
        const id = action.meta.arg.fileId;
        state.files = state.files.filter((file) => file.id !== id);
      }),
});

export const {
  setPrompt,
  setPromptDisabled,
  setShowPrompt,
  setSuggestions,
  setQuickReplies,
  setAttachments,
} = promptSlice.actions;
export const promptReducer = promptSlice.reducer;
